import { dedupedFetchAuthSession } from 'utils/api';

import { client } from '../../client/client.gen';

client.interceptors.request.use(async (request) => {
  try {
    const session = await dedupedFetchAuthSession();
    const accessToken = session.tokens?.idToken?.toString();
    if (accessToken) {
      request.headers.set('Authorization', `Bearer ${accessToken}`);
    }
  } catch (error) {
    console.error('Failed to get auth token:', error);
  }
  return request;
});

export { client };
